// src/pages/Analytics/CollapsibleSection.tsx
import React, { useState, ReactNode } from 'react';
import { DashBoardChartsContent } from '../styles';

interface CollapsibleSectionProps {
  title: string;
  children: ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section style={{ marginBottom: '24px' }}>
      <header
        onClick={() => setIsOpen(open => !open)}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
          background: '#f5f5f5',
          padding: '8px 16px',
          borderRadius: '4px',
          userSelect: 'none',
          marginBottom: '8px',
        }}
      >
        <h3 style={{ margin: 0 }}>{title}</h3>
        <span style={{ fontSize: '1.2em' }}>{isOpen ? '▾' : '▸'}</span>
      </header>
      {isOpen && <DashBoardChartsContent>{children}</DashBoardChartsContent>}
    </section>
  );
};

export default CollapsibleSection;
